<template>
    <nextpax-airbnb-vrbo-grid :url="url" :isNextpax="false" />
</template>

<script>
import { ADMIN_CHANNEL_COMMISSIONS_AIRBNB_GRID } from '../../../endpoints';
import NextpaxAirbnbVrboGrid from './common/nextpax-airbnb-vrbo-grid.vue';

export default {
    components: {
        NextpaxAirbnbVrboGrid,
    },
    computed: {
        url() {
            return ADMIN_CHANNEL_COMMISSIONS_AIRBNB_GRID();
        },
    },
};
</script>
